module.exports = __webpack_public_path__ + "static/media/4.2f5e22c5.jpg";